import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  IconButton,
  Typography,
  Chip,
  Stack,
  Paper
} from '@mui/material';
import {
  CloudOff as CloudOffIcon,
  Info as InfoIcon,
  Close as CloseIcon,
  Storage as StorageIcon,
  CheckCircle as CheckCircleIcon,
  PlayArrow as PlayArrowIcon
} from '@mui/icons-material';

// Désactivé : retourne null pour supprimer complètement la notification hors-ligne
const OfflineNotification = () => null;

export default OfflineNotification;
